import { useEffect } from 'react';

/**
 * Fixes a well-known native browser quirk: when a number input (<input type="number">)
 * is focused and the mouse happens to be hovering over it while the page is scrolled,
 * the browser silently increments/decrements the value instead of just scrolling the
 * page. That's what was causing prices/stock/quantities to randomly change while an
 * admin was scrolling the form.
 *
 * This blurs any focused number input the instant a wheel event reaches it, so
 * scrolling the page never edits a value — the user has to click the input's own
 * up/down arrows or type a new number on purpose.
 *
 * Mounted once near the app root; fixes every number input across the entire site,
 * including ones added later, with no per-input changes needed.
 */
const NumberInputWheelGuard = () => {
  useEffect(() => {
    const handleWheel = (e) => {
      if (document.activeElement?.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', handleWheel, { passive: true });
    return () => document.removeEventListener('wheel', handleWheel);
  }, []);

  return null;
};

export default NumberInputWheelGuard;
